import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MessagesEmptyStateComponent } from '../messages-empty-state/messages-empty-state.component';
import { SingleMessageComponent } from '../single-message/single-message.component';

@Component({
  selector: 'app-messages-chat',
  imports: [MessagesEmptyStateComponent, SingleMessageComponent],
  templateUrl: './messages-chat.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      height: 100%;
    }
  `,
})
export class MessagesChatComponent {
  public hasMessages = false;
}
